import { Component } from '@angular/core';
import { User } from '../../shared/models/auth';
import { Router } from '@angular/router';
import { environment } from "public/environments/environment";
import { AuthenticationService } from 'projects/shared/src/services/authentication.service';

@Component({
  selector: 'app-consumer-layout',
  templateUrl: './consumer-layout.component.html',
  standalone: false
})
export class ConsumerLayoutComponent {
  isOpened = false;
  currentUser: User | any = new User();
  appRedirectUrl = environment.appRedirectAdminUrl

  constructor(
    private router: Router,
    private authenticationService: AuthenticationService
  ) {
    this.currentUser = this.authenticationService.currentUserValue;
  }

  logout() {
    this.authenticationService.logout();
    this.router.navigate(['/login']);
  }
}
